import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=018b40c6"
import script from "./ModuleHeader.vue?vue&type=script&lang=ts"
export * from "./ModuleHeader.vue?vue&type=script&lang=ts"
import style0 from "./ModuleHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default})
